<div class="d-flex flex-column gap-1">
  <wl-checkbox
    [formsControl]="controls?.existingCustomer"
    [label]="content?.existingCustomerLabel ?? ''"
    [rendering]="rendering"
    [showValidation]="false"
    fieldName="I am a customer"
    wlAutomationId="i-am-a-customer-checkbox"
  />
  @if (showExistingCustomerMessage) {
    <div class="col-12">
      <wl-info-card
        wlAutomationId="i-am-a-customer-message"
        [title]="{ value: content?.existingCustomerTitle ?? '' }"
        [message]="{ value: content?.existingCustomerMessage ?? '' }"
        [border]="true"
        [shadow]="false"
        [buttonLink]="rendering?.fields?.ExistingCustomerButtonLink"
        [buttonType]="'button-outline'"
      />
    </div>
  }
</div>
